import React from 'react'
import { Box, styled } from '@mui/material'
import { convertFromRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import DOMPurify from 'isomorphic-dompurify'
import { FullWidth } from '../Misc/FullWidth'
import { draftJsOptionsObject } from '../Misc/utils'
import { storyTypography } from '../../../tokens/typography-storybuilder'
import { getContrastSafeColor } from '../Misc/utils'

type Props = {
  assetDetails: any
  style?: React.CSSProperties
  backgroundColor?: string
}
export const FreeTextBlockPublic = ({
  assetDetails,
  style,
  backgroundColor,
}: Props): JSX.Element => {
  if (assetDetails === null) {
    return <span />
  }
  return (
    <FullWidth backgroundColor={backgroundColor}>
      <Container style={style} backgroundColor={backgroundColor || '#FFFFFF'}>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              stateToHTML(convertFromRaw(assetDetails), draftJsOptionsObject)
            ),
          }}
        />
      </Container>
    </FullWidth>
  )
}

const Container = styled(Box)<{ backgroundColor: string }>`
  max-width: 672px;
  margin: 0 auto;
  ${storyTypography.freeTextBlock.styles};

  @media print {
    max-width: 744px !important;
  }
  & a {
    color: ${({ backgroundColor }) => getContrastSafeColor(backgroundColor)};
  }
`
